import React, { useState, useEffect } from 'react'
import { checkGaurantorcoborrowerByUserId } from '../../AdminActionCreator.component'
import MainNavbar from './MainNavbar'
import MainEdit from './EditUserDetailsAllApplications/Main'
import TabBox from './TabBox'
import LoanDetails from './LoanDetails'
import Logs from './Logs'
export default function Main({ ediDetailBackHandler, userDetails, admin }) {
    const [viewType, setviewType] = useState("")
    const [subViewType, setSubViewType] = useState("list")
    const [checkTab, setcheckTab] = useState({})
    const [viewIngData, setViewingData] = useState([])
    const [PayloadBorrowerId, setPayloadBorrowerID] = useState("")

    useEffect(() => {
        console.log("userDetails",userDetails)
        let id = "";
        if (userDetails?.userType == "BORROWER") {
            id = userDetails?.userId;
        }else{
            id = userDetails?.borrowerId;
        }
        setPayloadBorrowerID(id)
        setviewType("borrower")
setTimeout(()=>{
    checkGaurantorcoborrowerByUserIdFn(id)
},0)
    }, [])

    const handleviewType = (type) => {
        setviewType(type)
        handleSubViewtype("list")
        if (type === "coBorrower") {
            setViewingData(checkTab?.coBorrowers)
        } else if (type === "gaurantor") {
            setViewingData(checkTab?.guarantors)
        } else {
            setViewingData([])
        }
    }

    const handleSubViewtype = (type) => {
        setSubViewType(type)
    }

    const checkGaurantorcoborrowerByUserIdFn = (id) => {
        checkGaurantorcoborrowerByUserId(id, callback => {

            console.log("call", callback)
            if (callback?.status == 200 && callback?.message == "success") {
                setcheckTab(callback?.data)
                if(viewType == "coBorrower" && !callback?.data?.coBorrowerExist) {
                    setviewType("borrower")
                }
                if(viewType == "gaurantor" && !callback?.data?.guarantorExist) {
                    setviewType("borrower")
                }
            } else {
                setcheckTab({})
            }
        })
    }

    const handleBack = () => {
        if (subViewType == "details") {
            handleSubViewtype("list")
        } else {
            ediDetailBackHandler()
        }
    }

    const handlecheckborrowerApi = ()=>{
         checkGaurantorcoborrowerByUserIdFn(PayloadBorrowerId)
    }


    return (
        <>
            <MainNavbar
                handleBack={handleBack}
                allData={userDetails}
                viewType={viewType}
                handleviewType={handleviewType}
                checkTab={checkTab}
            />

            {
                viewType === "borrower" ?
                    <MainEdit
                        userDetails={userDetails}
                        viewType={viewType}
                        admin={admin}
                        PayloadBorrowerId={PayloadBorrowerId}
                    />
                    : ''}
            {
                viewType === "loanDetails" ?
                    <LoanDetails
                        userDetails={userDetails}
                         PayloadBorrowerId={PayloadBorrowerId}
                    />
                    : ''}

            {
                viewType === "coBorrower" || viewType == "gaurantor" ?
                    <TabBox
                        subViewType={subViewType}
                        handleSubViewtype={handleSubViewtype}
                        viewIngData={viewIngData}
                        viewType={viewType}
                        admin={admin} handlecheckborrowerApi={handlecheckborrowerApi}
                         PayloadBorrowerId={PayloadBorrowerId}
                    />
                    : ''}

            {
                viewType === "logs" ?
                    <Logs
                        userDetails={userDetails}
                        PayloadBorrowerId={PayloadBorrowerId}
                    />
                    : ''}
        </>
    )
}
